import isWithinInterval from "date-fns/isWithinInterval";
import set from "date-fns/set";
import { useAtomValue } from "jotai";
import { useCallback, useMemo } from "react";

import { accountAtom } from "shared/lib/account";

export const useGreetingMessage = () => {
  const { user } = useAtomValue(accountAtom);
  const getGreetingMessage = useCallback(() => {
    const currentDate = new Date();
    const morningStart = set(currentDate, { hours: 5, minutes: 0, seconds: 0 });
    const morningEnd = set(currentDate, { hours: 11, minutes: 59, seconds: 59 });
    const afternoonStart = set(currentDate, { hours: 12, minutes: 0, seconds: 0 });
    const afternoonEnd = set(currentDate, { hours: 17, minutes: 59, seconds: 59 });
    let message = "";

    if (isWithinInterval(currentDate, { end: morningEnd, start: morningStart })) {
      message = "Good morning";
    } else if (isWithinInterval(currentDate, { end: afternoonEnd, start: afternoonStart })) {
      message = "Good afternoon";
    } else {
      message = "Good evening";
    }
    if (user?.firstname) {
      return `${message}, ${user?.firstname}`;
    }
  }, [user?.firstname]);

  const greetingMessage = useMemo(() => getGreetingMessage(), [getGreetingMessage]);

  return { greetingMessage };
};
